import React from 'react';
import { PHONE_DISPLAY, PHONE_TEL, SMS_HREF, ADDRESS_LINE_1, ADDRESS_LINE_2, EMAIL } from '../../data/contact';
import SocialLinks from '../common/SocialLinks';
import TrialSchedulerModal from '../common/TrialSchedulerModal';

export function LandingTopBar() {
  return (
    <div className="w-full border-b border-outline-variant bg-surface">
      <div className="max-w-screen-xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src="/images/sflcm-logo.webp" alt="SFLCM" className="h-9 w-9 rounded-md" />
          <span className="font-headline text-base md:text-lg text-on-surface font-semibold tracking-tight">
            South Florida Conservatory of Music
          </span>
        </div>
        <div className="hidden sm:flex items-center gap-3">
          <a
            href={PHONE_TEL}
            className="inline-flex items-center gap-2 font-body text-sm text-primary hover:text-secondary no-underline"
          >
            <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>call</span>
            {PHONE_DISPLAY}
          </a>
          <span className="text-outline" aria-hidden="true">·</span>
          <a
            href={SMS_HREF}
            className="inline-flex items-center gap-2 font-body text-sm text-primary hover:text-secondary no-underline"
          >
            <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>chat_bubble</span>
            Text us
          </a>
        </div>
      </div>
    </div>
  );
}

export function LandingBottomBar() {
  return (
    <footer className="w-full border-t border-outline-variant bg-surface-container-low mt-auto">
      <div className="max-w-screen-xl mx-auto px-6 md:px-10 py-10 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm font-body text-on-surface-variant">
        <div>
          <div className="font-headline text-on-surface font-semibold mb-2">Visit</div>
          <a
            href={`https://maps.google.com/?q=${encodeURIComponent(`South Florida Conservatory of Music, ${ADDRESS_LINE_1}, ${ADDRESS_LINE_2}`)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:text-secondary no-underline"
          >
            <div>{ADDRESS_LINE_1}</div>
            <div>{ADDRESS_LINE_2}</div>
          </a>
        </div>
        <div>
          <div className="font-headline text-on-surface font-semibold mb-2">Contact</div>
          <a href={PHONE_TEL} className="block text-primary hover:text-secondary no-underline">{PHONE_DISPLAY}</a>
          <a href={SMS_HREF} className="block text-primary hover:text-secondary no-underline">Text us</a>
          <a href={`mailto:${EMAIL}`} className="block text-primary hover:text-secondary no-underline">{EMAIL}</a>
        </div>
        <div>
          <div className="font-headline text-on-surface font-semibold mb-2">Follow</div>
          <SocialLinks className="text-on-surface-variant" />
        </div>
      </div>
      <div className="max-w-screen-xl mx-auto px-6 md:px-10 pb-6 text-xs text-on-surface-variant">
        © {new Date().getFullYear()} South Florida Conservatory of Music. All rights reserved.
      </div>
    </footer>
  );
}

export default function LandingShell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-surface text-on-surface font-body pb-20 md:pb-0">
      <LandingTopBar />
      <main className="flex-1">{children}</main>
      <LandingBottomBar />
      <TrialSchedulerModal />
    </div>
  );
}
